'use strict';

define(['handlebars-loader!templates/error.html'], function (error) {

    function make(id, skin, title, body) {
        return error({
            id: id,
            skin: skin,
            title: title,
            body: body
        });
    }

    return make;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/view/error.js
 ** module id = 207
 ** module chunks = 0
 **/